import { ButtonGroup } from '@material-ui/core'
import PricingStore from '../stores/pricing-store'
import { MonthlyToggleEl } from '../elements'
import Button from '../../../../components/button'

const MonthlyToggle = () => {
  const { showMonthly, toggleMonthly } = PricingStore.useContainer()

  return (
    <MonthlyToggleEl showMonthly={showMonthly}>
      <ButtonGroup variant='contained'>
        <Button onClick={() => toggleMonthly(false)}>Bill Annually</Button>
        <Button onClick={() => toggleMonthly(true)}>Bill Monthly</Button>
      </ButtonGroup>
    </MonthlyToggleEl>
  )
}

export default MonthlyToggle
